import { Component, Inject, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common'
import { MatIcon } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { ProgressSpinnerMode, MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MappingResultService } from '../../../_services/mapping-result.service';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import { MarkdownModule } from 'ngx-markdown';
@Component({
  selector: 'app-ai-insights',
  standalone: true,
  imports: [ MatProgressSpinnerModule,
  MatGridListModule,MatIcon, CommonModule, MatExpansionModule,MatButtonModule,  MatDialogClose, MatDialogContent, MarkdownModule],
  templateUrl: './ai-insights.component.html',
  styleUrls: ['./ai-insights.component.scss']
})
export class AiInsightsComponent implements OnInit {
  insightData: any
  onlyRationale: boolean = false;
  showPdf(file_location:any) {
    this.mappingResultService.displayPdf(file_location);
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef< AiInsightsComponent>,
  private mappingResultService: MappingResultService) {
  }
  ngOnInit() {
    this.insightData = this.data;
    try {
      const rootShow = this.insightData && this.insightData.showOnly;
      const nestedShow = this.insightData && this.insightData.data && this.insightData.data.showOnly;
      this.onlyRationale = (rootShow === 'rationale') || (nestedShow === 'rationale');
    } catch (e) {
      this.onlyRationale = false;
    }
  }
  readonly panelOpenState = signal(false);
}
